import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../utils/api';

export const putAlertSupplierUnconfirmedConsolidatedreadCountSlice = createApi(`PutAlertSupplierUnconfirmedConsolidatedreadCountSlice`,"PUT");

const PutAlertSupplierUnconfirmedConsolidatedreadCountSlice = createSlice({
  name: 'PutAlertSupplierUnconfirmedConsolidatedreadCountSlice',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(putAlertSupplierUnconfirmedConsolidatedreadCountSlice.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(putAlertSupplierUnconfirmedConsolidatedreadCountSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(putAlertSupplierUnconfirmedConsolidatedreadCountSlice.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default PutAlertSupplierUnconfirmedConsolidatedreadCountSlice.reducer;